import React from 'react'
import {Nullable} from '../../../../Common/TypeHelper'
import MemberRepo from '../../../Repo/MemberRepo'
import {useParams} from 'react-router-dom'
import {useAsync} from 'react-use'
import {MBMemberError} from '../../../Common/MBMemberError'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {PIMPrimaryButton} from '../../Atoms/Buttons/Bases/PIMPrimaryButton'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {PIMCardActions} from '../../Atoms/Layouts/PIMCardActions'
import {MBContentBodyDivider} from '../../Atoms/Dividers'
import {MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {memberResponseStatusCheck} from '../../../Utils/MemberResponseStatusCheck'

type Props = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
}

export function MembersEditMailMagazineInfoPage(props: Props): Nullable<JSX.Element> {
  const {bucketKey} = useParams<{ bucketKey: string }>()

  const resultBucketInfo = useAsync(async () => {
    return await props.memberRepo.getBucketInfoByBucketKey(bucketKey)
  })
  const resultMemberBucketOptions = useAsync(async () => {
    return await props.memberRepo.getMemberBucketOptionsByBucketKey(bucketKey)
  })

  if (resultBucketInfo.loading) {
    return null
  }

  if (resultBucketInfo.error) {
    throw new MBMemberError(resultBucketInfo.error.message)
  }

  if (!resultBucketInfo.value) {
    throw new MBMemberError('UnknownError')
  }

  memberResponseStatusCheck(resultBucketInfo.value.status)

  if (!resultBucketInfo.value.data) {
    throw new MBMemberError('UnknownError')
  }

  if (resultMemberBucketOptions.loading) {
    return null
  }

  if (resultMemberBucketOptions.error) {
    throw new MBMemberError(resultMemberBucketOptions.error.message)
  }

  if (!resultMemberBucketOptions.value) {
    throw new MBMemberError('UnknownError')
  }

  memberResponseStatusCheck(resultMemberBucketOptions.value.status)

  if (!resultMemberBucketOptions.value.data) {
    throw new MBMemberError('UnknownError')
  }

  if (resultBucketInfo.value.data.mailMagazineList.length === 0) {
    throw new MBMemberError('NotFound')
  }

  const {mailMagazineList} = resultBucketInfo.value.data
  const filteredSubscribeMailMagazineIdList =
    mailMagazineList.filter((item) =>
      resultMemberBucketOptions.value.data?.subscribeMailMagazineIdList.includes(item.id))

  function goToEditMailMagazineInputPage(): void {
    props.navigator.goToEditMailMagazineInputPage(bucketKey)
  }

  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={{...resultBucketInfo.value.data}}
    >
      <PageTitle>メルマガ情報</PageTitle>

      <ContentBlock data-testid="block-mailMagazine-info">
        <MBContentBodyDivider/>

        <Spacer my={'18px'}>
          <MBContentSubTitleTypography>メルマガ</MBContentSubTitleTypography>
          {
            filteredSubscribeMailMagazineIdList.length === 0
              ? (
                <Spacer mt={'10px'}>
                  <p className="">メルマガのご希望はありません</p>
                </Spacer>
              )
              : (
                <Spacer mt={'10px'}>
                  <ul className="list-disc_01 fts15 mb_0">
                    {filteredSubscribeMailMagazineIdList.map(item =>
                      <li key={item.id}>{item.name}</li>,
                    )}
                  </ul>
                </Spacer>
              )
          }
        </Spacer>

        <MBContentBodyDivider/>

        <Spacer mt={'25px'}>
          <PIMCardActions>
            <PIMPrimaryButton onClick={goToEditMailMagazineInputPage}>
              メルマガ情報変更
            </PIMPrimaryButton>
          </PIMCardActions>
        </Spacer>
      </ContentBlock>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${resultBucketInfo.value.data.fcMyPageInfo.name ?? ''}に移動する`}
            url={resultBucketInfo.value.data.fcMyPageInfo.url}
          />
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
